import { create } from 'zustand';

interface RisksPageStore {
  showCreate: boolean;
  editRisk: unknown | null;
  deleteConfirm: string | null;
  setShowCreate: (open: boolean) => void;
  setEditRisk: (risk: unknown | null) => void;
  setDeleteConfirm: (id: string | null) => void;
}

export const useRisksPageStore = create<RisksPageStore>((set) => ({
  showCreate: false,
  editRisk: null,
  deleteConfirm: null,
  setShowCreate: (open) => set({ showCreate: open }),
  setEditRisk: (risk) => set({ editRisk: risk }),
  setDeleteConfirm: (id) => set({ deleteConfirm: id }),
}));
